import { render, staticRenderFns } from "./SidebarManager.vue?vue&type=template&id=000e09e9&"
import script from "./SidebarManager.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SidebarManager.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports